<template>
  <div>
    <section-title content="Información de SIFDE" has-line />
    <div v-if="listOfSIFDE.length == 0" class="bg-secondary-13 rounded my-3 ">
      <div class="col-12 py-4 text-center">
        <button
          v-if="!readOnly"
          class="btn bg-light-white col-12 col-md-4"
          @click="() => getVendorInfo(true)"
        >
          <em class="fas fa-file-plus pr-4 text-green" />
          <span class="text-button-add-document">
            Presione aquí para añadir informacion de SIFDE
          </span>
        </button>
        <custom-result-not-found v-else class="py-5" />
      </div>
    </div>
    <div v-else>
      <div class="mb-4 d-flex flex-row-reverse">
        <action-button
          v-if="!readOnly"
          id="btnAddEntry"
          i="far fa-undo"
          text="Actualizar PO"
          variant="outline-success pl-4 pr-4"
          @click="() => getVendorInfo(true)"
        />
      </div>
      <div class="row mb-4">
        <div class="col-12">
          <SIFDERow
            v-for="item in listOfSIFDE"
            :key="item.purchaseOrderId"
            :value="item"
            @on-update-po="onUpdatePoHandler"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { name } from '@/modules/provider/store';
import { mapState } from 'vuex';
import SectionTitle from '@/shared/components/SectionTitle';
import SIFDERow from './SIFDERow';
import CustomResultNotFound from 'custom-result-not-found';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import {
  getVendorInfo as _getVendorInfo,
  updatePurchaseOrderDetails as _updatePurchaseOrderDetails,
} from '@/modules/sifdeVendor/api.js';

export default {
  name: 'SIFDEInformation',
  components: {
    SectionTitle,
    SIFDERow,
    CustomResultNotFound,
  },
  mixins: [alertMixin],
  props: {
    contractNumber: {
      type: String,
      default: () => '',
    },
    academicYear: {
      type: String,
      default: () => '',
    },
    companyIdValue: {
      type: String,
      default: () => '',
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      listOfSIFDE: [],
      companyId: null,
      ssn: null,
    };
  },
  computed: {
    ...mapState(name, ['companySSN']),
  },
  watch: {
    academicYear() {
      this.getVendorInfo(false);
    },
  },
  mounted() {
    this.companyId = this.$route.params.companyId || this.companyIdValue;
    if (this.contractNumber && this.companyId) {
      this.getVendorInfo(false);
    }
  },
  methods: {
    async getVendorInfo(sync = true) {
      const { data } = await _getVendorInfo(
        this.companyId,
        this.contractNumber,
        sync
      ).catch(({ response }) => {
        this.ShowToast(
          '',
          response?.data?.message ||
            'No es posible realizar la consulta, intente más tarde.',
          'error'
        );
      });

      if (data) this.listOfSIFDE = data?.contractInfo?.purchaseOrders || [];
    },
    async onUpdatePoHandler({ purchaseOrderId, budgetRef }) {
      if (purchaseOrderId) {
        await _updatePurchaseOrderDetails(purchaseOrderId, budgetRef);
        if (this.validate()) await this.getVendorInfo(true);
        else return;
        this.ShowToast(
          '',
          'El PO ha sido actualizado exitosamente.',
          'success'
        );
      }
    },
    validate() {
      if (!this.contractNumber || !this.companyId) {
        this.ShowToast(
          '',
          'No es posible realizar la consulta, ya que no se encontró el contrato para el seguro social del proveedor.',
          'error'
        );
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
